// The URL's search after "New chat", `/new` or `/clear` inside a project (see App.jsx's handleNewChatInProject):
// the project stays, the conversationId moves off the previous conversation.
// - Code door (`freshId` given): the fresh id goes in, so the chat panel remounts on that new conversation.
// - /chat door (no `freshId`): the old id is dropped; the new one is added once the first message creates it.
// Returns null when the URL does not change.
export function searchForNewChatInProject(search, freshId) {
    const params = new URLSearchParams(search);
    if (freshId) {
        params.set('conversationId', freshId);
    } else if (params.has('conversationId')) {
        params.delete('conversationId');
    } else {
        return null;
    }
    const next = params.toString();
    return next ? `?${next}` : '';
}

// The URL's search once the fresh conversation has its real session id; null when it is already there.
export function searchForFreshConversation(search, sessionId) {
    const params = new URLSearchParams(search);
    if (!sessionId || params.get('conversationId') === sessionId) { return null; }
    params.set('conversationId', sessionId);
    return `?${params.toString()}`;
}
